<template>
  <div id="vip">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss">
</style>
